import { ActionIcon, ActionIconProps } from "PFComponents/action_icon";
import { Flex } from "PFComponents/containers";
import { Icon, IconProps } from "PFComponents/icon";
import { Tooltip, TooltipProps } from "PFComponents/tooltip";
import { IconName } from "PFTheme/graphics/icons";
import { ReactNode } from "react";

type TooltipIconProps = {
  content?: ReactNode;
  iconName?: IconName;
  tooltipProps?: Partial<TooltipProps<HTMLDivElement>>;
} & (
  | {
      onClick?: never;
      iconProps?: Partial<IconProps>;
    }
  | {
      onClick: NonNullable<ActionIconProps["onClick"]> | undefined;
      iconProps?: Partial<ActionIconProps>;
    }
);

export const TooltipIcon = ({
  content,
  iconName = "info",
  onClick,
  tooltipProps = {},
  iconProps = {}
}: TooltipIconProps) => {
  const { name, ...restIconProps } = iconProps;
  const { content: tooltipContent, triggerContainerProps = {}, ...restTooltipProps } = tooltipProps;

  return (
    <Tooltip content={tooltipContent ?? content} {...restTooltipProps}>
      {({ ref, getReferenceProps }) => (
        <Flex ref={ref} {...getReferenceProps(triggerContainerProps)} alignItems="center">
          {onClick ? (
            <ActionIcon onClick={onClick} name={name ?? iconName} {...restIconProps} />
          ) : (
            <Icon name={name ?? iconName} {...restIconProps} />
          )}
        </Flex>
      )}
    </Tooltip>
  );
};
